export default {
  inDevelopment: {
    summary: 'Plánovač výroby je vo vývoji',
    details: 'Tu budete na základe objednávok plánovať, ktoré vsádzky a kedy pobežia v jednotlivých peciach.',
  },
};
